import { checkForAddonRestError } from '../utils/index';

const getToken = () => new Promise((resolve) => window.AP.context.getToken(resolve));

export const createHeaders = (addonToken, headers = {}) => {
	const mergedHeaders = Object.assign(headers, {
		Authorization: `JWT ${addonToken}`,
	});

	return new Headers(mergedHeaders);
};

export const fetchData = (method = 'GET', url, data, headers) => {
	return getToken()
		.then((token) => {
			const params = {
				headers: createHeaders(token, headers),
				method,
			};

			if (method !== 'GET' && method !== 'HEAD' && data) {
				params.body = data;
			}

			return fetch(url, params);
		})
		.then((response) => checkForAddonRestError(response));
};
